import { defineComponent as _defineComponent } from 'vue'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';
import CommonInput from '../CommonInput.vue';
import CommonSwitch from '../CommonSwitch.vue';
import FormatUtils from '@/utils/format_utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'BenefitTypeValue',
  props: {
    icon: { type: Object, required: true },
    inputIcon: { type: Object, required: false },
    title: { type: String, required: true },
    subtitle: { type: String, required: false },
    description: { type: String, required: false },
    value: { type: String, required: true },
    isEnabled: { type: Boolean, required: true },
    errorText: { type: String, required: false }
  },
  emits: ["change", "set-is-enabled"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

function getState() {
  if (props.errorText) return 'error';
  return Boolean(props.value) || props.isEnabled ? 'default-money-benefit' : 'disabled';
}


const __returned__ = { props, emit, getState, get FontAwesomeIcon() { return FontAwesomeIcon }, CommonInput, CommonSwitch, get FormatUtils() { return FormatUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})